import Vue from 'vue'
import moment from 'moment'

moment.locale('sv');
Vue.prototype.moment = moment


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/moment.js